import API from '../../services/API'
import {
    MUSIC_LIST_GETTER,
    MUSIC_GETTER_MUSIC_BY_ID,
    MUSIC_MUTATION_ENTIRE_MUSIC,
    MUSIC_MUTATION_SINGLE_MUSIC_ATTRIBUTE,
    MUSIC_MUTATION_DELETE_MUSIC,
    MUSIC_MUTATION_ADD_MUSIC,
    MUSIC_ACTION_GET_MUSICS,
    MUSIC_ACTION_UPDATE_MUSIC,
    MUSIC_ACTION_DELETE_MUSIC,
    MUSIC_ACTION_CREATE_MUSIC,
    MUSIC_TYPE_CEREMONY_MUSICS,
    MUSIC_TYPE_CEREMONY_BANDS,
    MUSIC_TYPE_OBSERVANCE_MUSICS,
    MUSIC_TYPE_OBSERVANCE_BANDS

} from './music-types'

import Vue from 'vue'

export default {
    namespaced: true,

    state: {
        musics: {}
    },

    getters: {
        [MUSIC_LIST_GETTER]: (state) => (payload) => {
            if (state.musics.present == null) {
                return ''
            }
            switch (payload) {
            case MUSIC_TYPE_CEREMONY_MUSICS:
                return state.musics[MUSIC_TYPE_CEREMONY_MUSICS].map(music => music.id)
            case MUSIC_TYPE_CEREMONY_BANDS:
                return state.musics[MUSIC_TYPE_CEREMONY_BANDS].map(music => music.id)
            case MUSIC_TYPE_OBSERVANCE_MUSICS:
                return state.musics[MUSIC_TYPE_OBSERVANCE_MUSICS].map(music => music.id)
            case MUSIC_TYPE_OBSERVANCE_BANDS:
                return state.musics[MUSIC_TYPE_OBSERVANCE_BANDS].map(music => music.id)
            default:
                return ''
            }
        },
        [MUSIC_GETTER_MUSIC_BY_ID]: (state) => (payload) => {
            let id = payload['id']
            let category = payload['category']

            switch (category) {
            case MUSIC_TYPE_CEREMONY_MUSICS:
                return state.musics[MUSIC_TYPE_CEREMONY_MUSICS].find(music => music.id === id)
            case MUSIC_TYPE_CEREMONY_BANDS:
                return state.musics[MUSIC_TYPE_CEREMONY_BANDS].find(music => music.id === id)
            case MUSIC_TYPE_OBSERVANCE_MUSICS:
                return state.musics[MUSIC_TYPE_OBSERVANCE_MUSICS].find(music => music.id === id)
            case MUSIC_TYPE_OBSERVANCE_BANDS:
                return state.musics[MUSIC_TYPE_OBSERVANCE_BANDS].find(music => music.id === id)
            default:
                return ''
            }
        }
    },

    mutations: {
        [MUSIC_MUTATION_ENTIRE_MUSIC] (state, payload) {
            state.musics = payload[0]
        },
        [MUSIC_MUTATION_SINGLE_MUSIC_ATTRIBUTE] (state, payload) {
            let id = payload['id']
            let category = payload['category']
            let key = payload['key']
            let value = payload['value']
            let music = {}

            switch (category) {
            case MUSIC_TYPE_CEREMONY_MUSICS:
                music = state.musics[MUSIC_TYPE_CEREMONY_MUSICS].find(music => music.id === id)
                Vue.set(music, key, value)
                return
            case MUSIC_TYPE_CEREMONY_BANDS:
                music = state.musics[MUSIC_TYPE_CEREMONY_BANDS].find(music => music.id === id)
                Vue.set(music, key, value)
                return
            case MUSIC_TYPE_OBSERVANCE_MUSICS:
                music = state.musics[MUSIC_TYPE_OBSERVANCE_MUSICS].find(music => music.id === id)
                Vue.set(music, key, value)
                return
            case MUSIC_TYPE_OBSERVANCE_BANDS:
                music = state.musics[MUSIC_TYPE_OBSERVANCE_BANDS].find(music => music.id === id)
                Vue.set(music, key, value)
                return
            default:
                return ''
            }
        },
        [MUSIC_MUTATION_DELETE_MUSIC] (state, payload) {
            let id = payload['id']
            let category = payload['category']
            let index = null

            switch (category) {
            case MUSIC_TYPE_CEREMONY_MUSICS:
                index = state.musics[MUSIC_TYPE_CEREMONY_MUSICS].findIndex(music => music.id === id)
                state.musics[MUSIC_TYPE_CEREMONY_MUSICS].splice(index, 1)
                return
            case MUSIC_TYPE_CEREMONY_BANDS:
                index = state.musics[MUSIC_TYPE_CEREMONY_BANDS].findIndex(music => music.id === id)
                state.musics[MUSIC_TYPE_CEREMONY_BANDS].splice(index, 1)
                return
            case MUSIC_TYPE_OBSERVANCE_MUSICS:
                index = state.musics[MUSIC_TYPE_OBSERVANCE_MUSICS].findIndex(music => music.id === id)
                state.musics[MUSIC_TYPE_OBSERVANCE_MUSICS].splice(index, 1)
                return
            case MUSIC_TYPE_OBSERVANCE_BANDS:
                index = state.musics[MUSIC_TYPE_OBSERVANCE_BANDS].findIndex(music => music.id === id)
                state.musics[MUSIC_TYPE_OBSERVANCE_BANDS].splice(index, 1)
                return
            default:
                return ''
            }
        },
        [MUSIC_MUTATION_ADD_MUSIC] (state, payload) {
            switch (payload.musicType) {
            case MUSIC_TYPE_CEREMONY_MUSICS:
                state.musics[MUSIC_TYPE_CEREMONY_MUSICS].push(payload)
                return
            case MUSIC_TYPE_CEREMONY_BANDS:
                state.musics[MUSIC_TYPE_CEREMONY_BANDS].push(payload)
                return
            case MUSIC_TYPE_OBSERVANCE_MUSICS:
                state.musics[MUSIC_TYPE_OBSERVANCE_MUSICS].push(payload)
                return
            case MUSIC_TYPE_OBSERVANCE_BANDS:
                state.musics[MUSIC_TYPE_OBSERVANCE_BANDS].push(payload)
                return
            default:
                return ''
            }
        }
    },

    actions: {
        [MUSIC_ACTION_GET_MUSICS] ({ commit }) {
            return new Promise(
                function (resolve, reject) {
                    API.loadMusics()
                        .then((musicsData) => {
                            commit(MUSIC_MUTATION_ENTIRE_MUSIC, musicsData.musics)
                            resolve()
                        })
                        .catch((error) => {
                            console.log('' + error.message)
                            reject(error)
                        })
                })
        },
        [MUSIC_ACTION_CREATE_MUSIC] ({ commit }, payload) {
            return new Promise(
                function (resolve, reject) {
                    API.createMusic(payload)
                        .then((musicData) => {
                            commit(MUSIC_MUTATION_ADD_MUSIC, musicData)
                            resolve()
                        })
                        .catch((error) => {
                            console.log('' + error.message)
                            reject(error)
                        })
                })
        },
        [MUSIC_ACTION_DELETE_MUSIC] ({commit, state}, payload) {
            API.deleteMusic(payload.id)
                .then(() => {
                    commit(MUSIC_MUTATION_DELETE_MUSIC, payload)
                })
                .catch((error) => console.log(error.message))
        },
        [MUSIC_ACTION_UPDATE_MUSIC] ({commit, state}, payload) {
            API.saveMusic(payload)
                .then((musicData) => {})
                .catch((error) => console.log(error.message))
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/music.js